import { navigationMenuLinks } from './navigation-links.js';

function generateFooterNavigation() {
    const container = document.getElementById('footer-dynamic-nav');
    if (!container) return;

    const ul = document.createElement('ul');

    navigationMenuLinks.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'footer-nav-item';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'footer-nav-toggle';
        button.dataset.navId = item.id;
        button.textContent = item.text;
        li.appendChild(button);

        if (item.links && item.links.length > 0) {
            const subUl = document.createElement('ul');
            subUl.className = 'footer-nav-submenu';

            item.links.forEach((subItem) => {
                const subLi = document.createElement('li');
                const a = document.createElement('a');
                a.href = subItem.link;
                a.textContent = subItem.text;

                if (subItem.newTab) {
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';
                }

                subLi.appendChild(a);
                subUl.appendChild(subLi);
            });
            li.appendChild(subUl);
        }
        ul.appendChild(li);
    });

    container.appendChild(ul);
}

export function footerNavigation() {
    generateFooterNavigation();
    const footerNav = document.querySelector('.footer-nav--js');

    if (!footerNav) {
        return;
    }

    const toggleButtons = footerNav.querySelectorAll('.footer-nav-toggle');

    toggleButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            const isActive = this.classList.contains('active');
            const currentSubmenu = this.nextElementSibling;

            // Close all other submenus and remove active state
            toggleButtons.forEach((btn) => {
                if (btn !== this) {
                    btn.classList.remove('active');
                    const otherSubmenu = btn.nextElementSibling;
                    if (otherSubmenu && otherSubmenu.classList.contains('footer-nav-submenu')) {
                        otherSubmenu.classList.remove('show');
                    }
                }
            });

            // Toggle current submenu
            if (isActive) {
                this.classList.remove('active');
                if (currentSubmenu) {
                    currentSubmenu.classList.remove('show');
                }
            } else {
                this.classList.add('active');
                if (currentSubmenu) {
                    currentSubmenu.classList.add('show');
                }
            }
        });
    });
}
